import Device from 'baseStyles/enums/device';
import { useTopWindowSize } from 'hooks/useTopWindowSize';
import React, { useContext, useMemo } from 'react'
import { useMediaQuery } from 'react-responsive';

export const DeviceTypes = Device.types;
interface IAppMediaProviderState {
    isDesktop: boolean;
    isTablet: boolean;
    isMobile: boolean;
    isMobileSmall: boolean;
    isMobileSmallLandscape: boolean;
    isMobileLandscape: boolean;
    currentDevice: Device.types;
};

const AppMediaProviderContext = React.createContext({} as IAppMediaProviderState);

const AppMediaProvider = ({ children }: any) => {
    const windowSize =  useTopWindowSize();
    const isDesktop = useMediaQuery({ minWidth: Device.breakpoints[Device.types.Desktop].min }, windowSize);
    const isTablet = useMediaQuery({ minWidth: Device.breakpoints[Device.types.Tablet].min, maxWidth: Device.breakpoints[Device.types.Tablet].max }, windowSize);
    const isMobile = useMediaQuery({ maxWidth: Device.breakpoints[Device.types.Mobile].max }, windowSize);
    const isMobileSmall = useMediaQuery({ maxWidth: Device.breakpoints[Device.types.MobileSmall].max }, windowSize);
    const isMobileSmallLandscape = useMediaQuery({ maxWidth: Device.breakpoints[Device.types.MobileSmall].max, orientation: "landscape" }, windowSize);
    const isMobileLandscape = useMediaQuery({ maxWidth: Device.breakpoints[Device.types.Mobile].max, orientation: "landscape"}, windowSize);

    const currentDevice: Device.types = useMemo(() => {
        if (isDesktop) return Device.types.Desktop;
        else if (isTablet) return Device.types.Tablet;
        else if (isMobile) return Device.types.Mobile;
        else if (isMobileLandscape) return Device.types.MobileLandscape
    }, [isDesktop, isTablet, isMobile, isMobileLandscape]);

    const values: IAppMediaProviderState = {
        isDesktop,
        isTablet,
        isMobile,
        isMobileSmall,
        isMobileLandscape,
        isMobileSmallLandscape,
        currentDevice
    };

    return (
        <AppMediaProviderContext.Provider value={values}>
            <div data-width={windowSize.width} data-height={windowSize.height} className={`media-device-${currentDevice}`}>
                {children}
            </div>
        </AppMediaProviderContext.Provider>
    )
}

export const useAppMediaProvider = () => {
    const context = useContext(AppMediaProviderContext);
    if (!context) {
        // throw Error(`Use ${useAppMediaProvider.name} in ${AppMediaProviderContext.displayName}`);
        console.warn(`Use ${useAppMediaProvider.name} in ${AppMediaProviderContext.displayName}`);
    }
    return context;
};

export default AppMediaProvider